import { render, staticRenderFns } from "./ColorUnit.vue?vue&type=template&id=1d594394&scoped=true"
import script from "./ColorUnit.vue?vue&type=script&lang=ts"
export * from "./ColorUnit.vue?vue&type=script&lang=ts"
import style0 from "./ColorUnit.vue?vue&type=style&index=0&id=1d594394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d594394",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
